export type GraphqlDocument = {
    source: string;
    documents: Record<string, true>;
    __document: true;
  };
  
  export const gql = (
    literals: string | readonly string[],
    ...args: any[]
  ): GraphqlDocument => {
    let source = '';
    let documents = {};
    const sources = typeof literals === 'string' ? [literals] : literals;
  
    sources.forEach((currentSource, idx) => {
      source += `${currentSource.trim()} `;
  
      const keyword = args[idx];
  
      if (keyword) {
        if ('__document' in keyword) {
          documents = {
            ...documents,
            ...(keyword as GraphqlDocument).documents,
            [keyword.source]: true,
          };
        } else {
          source += `${keyword} `;
        }
      }
    });
  
    if (process.env.NODE_ENV !== 'production') {
      if (!source.match(/(fragment|query|mutation)/)) {
        throw new Error(`Invalid document.\n${source}`);
      }
    }
  
    return {
      __document: true,
      documents,
      source,
    };
  };
  
  const bodyMap = new Map<string, string>();
  
  export const getGqlBody = (document: GraphqlDocument) => {
    const cached = bodyMap.get(document.source);
    if (cached) {
      return cached;
    }
  
    const body = `
    ${document.source}
    ${Object.keys(document.documents).join('\n')}
  `
      .trim()
      .replace('\n', ' ');
    bodyMap.set(document.source, body);
  
    return body;
  };